<div class="measurements">
    <ng-container *ngIf="measurements && measurements.items && measurements.items.length > 0 else noMeasurements">
        <p-accordion (onOpen)="onSelect($event.index)">
            <ng-container *ngFor="let measurement of measurements.items; let index = index">
                <p-accordionTab>
                    <ng-template pTemplate="header">
                        <app-scroll-list-item
                            index="index"
                            class="list-item"
                            leftIcon="fa-signal"
                            rightIcon="{{getRightIcon(measurement)}}"
                            background="{{measurement.status === 3 ? 'yellow' : 'default'}}"
                            [hasDelete]="canDelete"
                            [text]="computeTextColor(measurement)"
                            [title]="measurement?.measurementDate "
                            [subtitle]="buildSubtitle(measurement)"
                            [description]="measurement?.riskClass?.name"
                            [item]="measurement"
                            (rightIconClick)="onActionClicked(measurement)"
                            (deleteClick)="onDeleteClicked(measurement)">
                        </app-scroll-list-item>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <app-strain-measurement-result-card [measurement]="measurement"
                                                            (reportClick)="onReportClick($event)"
                                                            (reportDelete)="onReportDelete($event)">
                        </app-strain-measurement-result-card>
                    </ng-template>
                </p-accordionTab>
            </ng-container>
        </p-accordion>
    </ng-container>

    <ng-template #noMeasurements>
        <ng-container *ngIf="!isLoading else loading">
            <div class="empty-message">
                {{ 'admin.strain.registry.details.measurements.noMeasurements' | translate }}
            </div>
        </ng-container>
    </ng-template>

    <ng-template #loading>
        <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
    </ng-template>
</div>
